import UserIndex from '../components/User/Index'
import UserForm from '../components/User/Form'
import Profile from '../components/User/Profile'
import PasswordChange from '../components/User/PasswordChange'

export default [
  {
    path: '/users',
    name: 'userIndex',
    component: UserIndex,
    meta: {
      breadcrumbs: [
        { text: 'ユーザ管理' },
      ],
    },
  },
  {
    path: '/user/create',
    name: 'userCreate',
    component: UserForm,
    props: {
      isNew: true,
    },
    meta: {
      breadcrumbs: [
        { text: 'ユーザ管理' },
      ],
    },
  },
  {
    path: '/users/:id',
    name: 'userUpdate',
    component: UserForm,
    props: true,
    meta: {
      breadcrumbs: [
        { text: 'ユーザ管理' },
      ],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      breadcrumbs: [
        { text: 'ユーザ管理' },
      ],
    },
  },
  {
    path: '/account',
    name: 'account',
    component: PasswordChange,
    meta: {
      breadcrumbs: [
        { text: 'パスワードの変更' },
      ],
    },
  },
]
